<div [class]="className">
    <p class="standard {{ errorClass }}">{{ charactersRemainingString }}</p>
</div>
